module.exports = __webpack_public_path__ + "static/img/SV@3x.87e5f93c.jpg";